import SpinnerExample from "./examples/Spinner.Example";
import SpinnerLabelExample from './examples/Spinner.Label.Example';

export default [
    {
        title: "Spinner",
        component: SpinnerExample,
        code: require("!raw-loader!./examples/Spinner.Example.tsx")
    },
    {
        title: "Spinner with Label",
        component: SpinnerLabelExample,
        code: require("!raw-loader!./examples/Spinner.Label.Example.tsx")
    }
];
